import styled from 'styled-components';

const Button = styled.button`
    background: ${props => (props.primary ? props.theme.button.primary : props.theme.button.secondary)};
    color: ${props => (props.primary ? props.theme.primaryTextColor : props.theme.secondaryTextColor)};
    cursor: pointer;
    font-weight: ${props => props.fontWeight || 'bold'};
    border: 2px solid #fff;
    border-radius: 5px;
    background-size: contain;
    &:active {
        background: ${props =>
            (props.primary && props.theme.button.primaryActive) || props.theme.button.secondaryActive};
    }
`;

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button.js